import { postEmailChangeAPI, POSTEmailChangeReqBody } from '@myme/api';
import { sendRequest } from '@myme/utils';

/* **** POST **** /blobs-library */
export const handleChangeEmail = async (reqBody: POSTEmailChangeReqBody) =>
  sendRequest<null, POSTEmailChangeReqBody>(postEmailChangeAPI, {
    reqBody
  });
